import "./ServiceContact.scss";
import ContactMeButton from "../../components/ContactMeButton/ContactMeButton";
import EmailMeButton from "../../components/EmailMeButton/EmailMeButton";

export default function ServiceContact({ heading, subheading }) {
  return (
    <div className="service-contact">
      <h2>{heading}</h2>
      <h5>{subheading}</h5>

      {/* Button Container */}
      <div className="contact-me__button-container">
        <ContactMeButton 
          label="Contact me"
          href="/contact"
          variant="default" 
        />
        <div>
          <EmailMeButton
            email="lindsayadamsdesign@gmail.com"
            textColor="#1F2022"
            iconColor="#1F2022"
          />
        </div>
      </div>
    </div>
  );
}
